export default __webpack_public_path__ + "static/media/e3.f30837e9.jpeg";